/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { getConfig } from 'blb-utils/config';
import { PipelinePage as OldPipeline } from './OldPipeline/PipelinePage';
import { PipelinePage as NewPipeline } from './NewPipeline/PipelinePage';

export const PipelinePage: React.FC<{}> = () => {
  const { useElasticSearch } = getConfig();
  return useElasticSearch ? <NewPipeline /> : <OldPipeline />;
};
